import { Field, Form, Formik } from "formik";
import React, { useEffect, useState } from "react";
import { Modal } from "react-bootstrap";
import Select from "react-select";
import ButtonBasic from "../../../../components/Buttons/ButtonBasic";
import Toast from "../../../../components/Toast/Toast";

const ChainIDModal = ({
  values,
  dsaFields,
  dsbFields,
  handleSubmit,
  show,
  onHide,
  editObject,
}) => {
  const [formValues, setFormValues] = useState(values);
  useEffect(() => {
    if (values) setFormValues(values);
  }, [values]);
  return (
    <Formik
      enableReinitialize
      initialValues={formValues}
      onSubmit={(values) => {
        if (!values?.ds_a_field_name && !values?.ds_b_field_name) {
          Toast(
            "It's mandatory to input the value of one field from the DSA Field Name or the DSB Field Name",
            "error"
          );
          return;
        }
        values = Object.fromEntries(
          Object.entries(values).filter(([, v]) => v !== "")
        );
        handleSubmit(editObject?.path, values);
        setFormValues({});
        onHide();
      }}
    >
      {({ handleSubmit, values, setFieldValue, setValues }) => (
        <Form id="chainIDForm" className="form" onSubmit={handleSubmit}>
          <Modal
            backdrop={true}
            size="xl"
            aria-labelledby="example-modal-sizes-title-lg"
            show={show}
            onHide={() => onHide()}
          >
            <Modal.Header closeButton>
              {editObject?.isNew ? "Add Chain ID Field" : "Edit Chain ID Field"}
            </Modal.Header>
            <Modal.Body scrollable="true">
              <div className="p-3 my-3">
                <div className="row">
                  <div className="col-4">
                    {/* Label Text Field */}
                    <div className="workflowModalTitle">Label</div>
                    <Field
                      id="label"
                      title={values?.label}
                      className="form-control rs-input highlight"
                      type="text"
                      placeholder="Label"
                      name={`label`}
                      onChange={(e) => setFieldValue(`label`, e.target.value)}
                    />
                  </div>
                  <div className="col-4">
                    {/* DS A Field Name DropDown */}
                    <div className="workflowModalTitle">DSA Field Name</div>
                    <div title={values?.ds_a_field_name}>
                      <Select
                        id="ds_a_field_name"
                        classNamePrefix="ds_a_field_name"
                        options={dsaFields}
                        name={"ds A Field Name"}
                        value={dsaFields?.find(
                          (field) => field.value == values?.ds_a_field_name
                        )}
                        onChange={(e) =>
                          setFieldValue(`ds_a_field_name`, e?.value)
                        }
                        isClearable
                      />
                    </div>
                  </div>
                  <div className="col-4">
                    {/* DS B Field Name DropDown */}
                    <div className="workflowModalTitle">DSB Field Name</div>
                    <div title={values?.ds_b_field_name}>
                      <Select
                        id="ds_b_field_name"
                        classNamePrefix="ds_b_field_name"
                        options={dsbFields}
                        name={"ds B Field Name"}
                        value={dsbFields?.find(
                          (field) => field.value === values?.ds_b_field_name
                        )}
                        onChange={(e) =>
                          setFieldValue(`ds_b_field_name`, e?.value)
                        }
                        isClearable
                      />
                    </div>
                  </div>
                </div>
              </div>
            </Modal.Body>
            <Modal.Footer>
              <div className="d-flex">
                <ButtonBasic
                  id="cancel"
                  title="Cancel"
                  onClick={() => onHide()}
                />
              </div>
              <button
                id="submit"
                type="submit"
                name="submit"
                className={"btn btn-info btn-md mr-2"}
                onClick={handleSubmit}
              >
                {editObject?.isNew ? "Add" : "Update"}
              </button>
            </Modal.Footer>
          </Modal>
        </Form>
      )}
    </Formik>
  );
};

export default ChainIDModal;
